import React from "react";
import {
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";



function ChatListItems({ chat, Key, info, tab}) {
  const history = useHistory();

  const handleClick = () => {
    history.push(`/c/${chat.roomID}`);
  };

  return (
      <ListItem onClick={tab? null: handleClick} button key={Key}>
          <ListItemAvatar>
              <Avatar
                alt={chat.name}
                src={
                  chat.photoURL === ""
                    ? `https://via.placeholder.com/50?text=${chat.name[0]}`
                    : chat.photoURL
                }
              >
                {chat.name}
              </Avatar>
          </ListItemAvatar>
        <ListItemText primary={chat.name} secondary={info} />
      </ListItem>
  );
}

export default ChatListItems;
